import * as yup from 'yup'
import { ContactSchema, INewContact } from 'apps/fleet-planner/schema/ContactSchema'
import * as Types from 'apps/fleet-planner/types'

export interface IUpdatedCustomer extends Pick<Types.ICustomer, 'notes'> {
  id?: string
  contact?: INewContact
}

/**
 * Creates a new customer
 * @note This model is not a 1-to-1 match to ICustomer. It reshapes the request and
 * makes `contact` into an object instead of an array. This works better in the context
 * of a form object.
 * @see https://fp-staging.transfix.io/api-docs/index.html#/Customers/post_customers
 */
export const EditCustomerSchema = yup.object<IUpdatedCustomer>({
  notes: yup.string().notRequired(),
  contact: ContactSchema.notRequired(),
})

export type EditCustomerSchemaType = yup.InferType<typeof EditCustomerSchema>
